/**
 * Scroll a chat scroll-container to one message bubble and flash it.
 *
 * Bubbles are tagged `data-message-id`; the caller has already made sure the
 * message is in the DOM (`useInternalChat().ensureMessageLoaded`). Returns
 * false when the bubble isn't rendered, so the caller can tell the user.
 */
export const JUMP_HIGHLIGHT_CLASS = "chat-jump-highlight";
const HIGHLIGHT_MS = 1600;

export function flashMessage(
  container: HTMLElement | null | undefined,
  messageId: string,
): boolean {
  if (!container) return false;
  const el = container.querySelector<HTMLElement>(
    `[data-message-id="${CSS.escape(messageId)}"]`,
  );
  if (!el) return false;
  el.scrollIntoView({ block: "center", behavior: "smooth" });
  el.classList.add(JUMP_HIGHLIGHT_CLASS);
  window.setTimeout(() => el.classList.remove(JUMP_HIGHLIGHT_CLASS), HIGHLIGHT_MS);
  return true;
}

/** Two animation frames — enough for React to commit prepended pages. */
export const afterPaint = () =>
  new Promise<void>((r) => requestAnimationFrame(() => requestAnimationFrame(() => r())));
